export default __webpack_public_path__ + "static/media/bg-3.457b99fe.jpg";